import { owaMultiplier } from 'console/device-settings/owa';
import { createSubsetSelector } from 'webui/utils/selectors';
import { prettyFloat } from 'webui/utils/number';
import { getOpenThermStateName, OpenThermVariableName } from 'openTherm';
import { getLegacyBoilerName, getLegacyOpenThermObserveParams, notAvailableOTFlags, } from '../../utils/open-therm';
import { removeNulls } from 'utils';
import { boiler_adapter_ot_color } from 'z3k-settings/components/utils/ColorPicker4bit';
import { owaAxis } from 'console/tabs/graphs/components/graph/utils/owa-axes';
export const legacy_thermometers_state = createSubsetSelector([
    'rf_status',
    'thermometers',
    'last_boiler_state',
    'internet_weather',
    'otzones_last',
]);
export const legacy_thermometers_config = createSubsetSelector([
    'rf_status',
    'thermometers',
    'ot_enabled',
    'ot_save_params',
    'internet_weather',
    'thermostat_zones_settings',
    'ot_zones_count',
]);
const legacy_open_therm_thermometers = [
    { ot_name: OpenThermVariableName.bt, unit: '°', limits: { high: null, low: null } },
    { ot_name: OpenThermVariableName.dt, unit: '°', limits: { high: null, low: null } },
    { ot_name: OpenThermVariableName.rwt, unit: '°', limits: { high: null, low: null } },
    { ot_name: OpenThermVariableName.ot, unit: '°', limits: { high: null, low: null } },
];
export function isRadioThermometer(thermometer) {
    return thermometer.type === 'radio';
}
export function isOutsideThermometer(thermometer) {
    return (thermometer.function == 'outside' ||
        thermometer.functions.some(({ f }) => f == 'outside'));
}
export function getLegacyRadioThermometers(thermometers, rf_status) {
    const legacy_radio_thermometers = Object.entries(rf_status || {}).map(([serial, sensor]) => {
        const { slot, name, uninitialized = true } = sensor;
        const thermometer_info = thermometers.find((thermometer) => thermometer.serial === serial) ??
            {};
        if (uninitialized) {
            return null;
        }
        if (Object.keys(thermometer_info).length > 0 &&
            isOutsideThermometer(thermometer_info)) {
            return null;
        }
        const { color, limits } = thermometer_info;
        const thermometer = {
            slot: slot + 0.2,
            name: name ? name.toString() : '',
            color: color ? color : '',
            serial,
            limits: limits ? limits : { low: null, high: null },
        };
        return thermometer;
    });
    return removeNulls(legacy_radio_thermometers);
}
export function getSharedThermometer(thermometer) {
    const { slot, name: label, color, limits, serial } = thermometer;
    const id = slot;
    const multiplier = owaMultiplier(thermometer);
    const { low, high } = limits;
    const axis_key = owaAxis(serial);
    const owa = {
        axis_key,
        multiplier,
    };
    return {
        id,
        name: label,
        color,
        limits: {
            high: high ? Number(prettyFloat(high * multiplier, 1)) : null,
            low: low ? Number(prettyFloat(low * multiplier, 1)) : null,
        },
        serial,
        owa,
    };
}
export function getLegacyOpenThermThermometer(props) {
    const { id: boiler_adapter_id, ot_save_params, name = boiler_adapter_id === 1 ? `Котел` : `Котел ${boiler_adapter_id}`, } = props;
    const observed_open_therm_flags = getLegacyOpenThermObserveParams(legacy_open_therm_thermometers, ot_save_params);
    return observed_open_therm_flags.map((sensor, index) => {
        const { ot_name, unit, limits } = sensor;
        const open_therm_name = `${name} ${getOpenThermStateName(ot_name)}`;
        // need for don't intersect thermometers
        const id = (index + boiler_adapter_id + 0.1);
        const open_therm = {
            ot_name,
            boiler_adapter_id,
        };
        return {
            id,
            name: open_therm_name,
            open_therm,
            unit,
            color: boiler_adapter_ot_color[0],
            limits,
            boiler_adapter_id,
        };
    });
}
export function getLegacyOpenThermThermometers(device) {
    const { ot_zones_count, ot_save_params, ot_enabled, thermostat_zones_settings } = device;
    //1 АЦШ
    if (ot_enabled && ot_zones_count == 1) {
        const name = getLegacyBoilerName(thermostat_zones_settings, 1);
        const open_therm_sensors = getLegacyOpenThermThermometer({
            id: 1,
            name,
            ot_save_params,
        });
        return open_therm_sensors;
    }
    // > 1 АЦШ
    const open_therm_sensors = Array(ot_zones_count)
        .fill(null)
        .flatMap((_zone, ot_index) => {
        const id = Number(ot_index + 1);
        const name = getLegacyBoilerName(thermostat_zones_settings, id);
        return getLegacyOpenThermThermometer({
            id,
            name,
            ot_save_params,
        });
    });
    return open_therm_sensors;
}
export function getLegacyWeatherThermometer(device, weather_thermometer) {
    const { ot_enabled, internet_weather, ot_save_params } = device;
    if (weather_thermometer) {
        return getSharedThermometer(weather_thermometer);
    }
    // Если таких не нашли, то идём по АЦШ. Смотрим на галочки, можно ли читать такой параметр.
    if (ot_enabled) {
        if (!notAvailableOTFlags(ot_save_params).has(OpenThermVariableName.ot)) {
            return {
                id: 10002,
                name: 'Погода',
                is_internet_thermometer: true,
                open_therm: {},
            };
        }
    }
    // Если указано местоположение - показываем погоду из интернета
    if (internet_weather != null) {
        return {
            id: 10001,
            name: 'Погода',
            is_internet_thermometer: true,
        };
    }
    return null;
}
